export const BASIC_PROVIDER_TYPE = 'BASIC';
export const COGNITO_PROVIDER_TYPE = 'COGNITO_PROVIDER';

export const PROVIDER_REFRESH_TOKEN_REQUEST = {
  [BASIC_PROVIDER_TYPE]: {
    url: 'session/refresh',
    type: 'get',
    config: null,
  },
  [COGNITO_PROVIDER_TYPE]: {
    url: 'cognitoSession/refresh',
    type: 'post',
    config: { headers: { 'Content-Type': 'application/json' } },
  },
  [undefined]: {},
};
